module.exports = __webpack_public_path__ + "img/ic_user setting.77f69b8d.svg";